import React, { createContext, useState, useCallback } from 'react'
import { useFormContext } from 'react-hook-form'
import withConfig from '../../../../../wrappers/withConfig'

const SelectColumnsContext = createContext(null)

const SelectColumnsContextProvider = ({ config, children }) => {
    const { API_URL } = config
    const [leftTableHighlights, setLeftTableHighlights] = useState([])
    const [rightTableHighlights, setRightTableHighlights] = useState([])

    const [leftTableData, setLeftTableData] = useState([])
    const [rightTableData, setRightTableData] = useState([])

    const [rightTableFunctions, setRightTableFunctions] = useState({
        append: null,
        remove: null,
    })

    const { setValue, getValues } = useFormContext()

    const assign = useCallback(
        (all = false) => {
            //assign highlighted rows from left to right
            const rowList = all ? leftTableData : leftTableHighlights
            if (
                rightTableFunctions &&
                rightTableFunctions.append &&
                rowList &&
                rowList.length
            ) {
                const targetTableValues = rowList.map((v) => ({
                    sourceColumn: v.sourceColumn,
                    dataType: v.columnType,
                    alias: null,
                    function: null,
                    functionArgument: null,
                    aggregateFunction: null,
                }))
                rightTableFunctions.append(targetTableValues)

                setValue('columns', rightTableFunctions)

                // Clear highlights after assignment
                setLeftTableHighlights([])
            }
        },
        [leftTableHighlights, rightTableFunctions, leftTableData, setValue]
    )

    const unassign = useCallback(
        (all = false) => {
            //assign highlighted rows from left to right
            if (rightTableFunctions && rightTableFunctions.remove) {
                if (all) {
                    rightTableFunctions.remove()
                } else {
                    const indexList = rightTableHighlights
                        .map((v) => v.rowIndex)
                        .sort((a, b) => b - a) //OUR VERSION OF REACTHOOKFORM IS BUGGED!!!!! in their source code the removeArrayAt function has flawed logic so you need to sort arrays DESC in order to remove multiple fields
                    rightTableFunctions.remove(indexList)
                }
                setValue('columns', rightTableFunctions)

                // Clear highlights after assignment
                setRightTableHighlights([])
            }
        },
        [rightTableHighlights, rightTableFunctions, setValue]
    )

    return (
        <SelectColumnsContext.Provider
            value={{
                leftTableHighlights,
                setLeftTableHighlights,
                rightTableHighlights,
                setRightTableHighlights,
                rightTableFunctions,
                setRightTableFunctions,
                assign,
                unassign,
                rightTableData,
                setRightTableData,
                leftTableData,
                setLeftTableData,
            }}
        >
            {children}
        </SelectColumnsContext.Provider>
    )
}

export { SelectColumnsContext }
export default withConfig(SelectColumnsContextProvider)
